import { createFileRoute } from "@tanstack/react-router";
import { HubSeoContent } from "@/components/seo/HubSeoContent";
import { ToolsIndexPage } from "@/pages/tools/ToolsPages";
import { breadcrumbJsonLd } from "@/config/seoConfig";
import { seoHead, SITE_BASE_URL } from "@/lib/seo/head";

export const Route = createFileRoute("/tools/")({
  // Imported on demand so the tool registry is not in every page's startup code.
  loader: async () => {
    const { INDEXABLE_TOOLS } = await import("@/content/tools");
    return { tools: INDEXABLE_TOOLS.map((t) => ({ title: t.title, route: t.route })) };
  },
  head: ({ loaderData }) => seoHead({
    title: "Free Parent Resources for Children’s Life Skills",
    description: "Free guides, checks, conversation starters and printable planners for parents helping children aged 8–14 build practical life skills.",
    canonical: "/tools", pageType: "CollectionPage",
    jsonLd: [
      breadcrumbJsonLd([{ name: "Home", url: "/" }, { name: "Free Parent Tools", url: "/tools" }]),
      { "@type": "ItemList", "@id": `${SITE_BASE_URL}/tools#list`, itemListElement: (loaderData?.tools ?? []).map((tool, index) => ({ "@type": "ListItem", position: index + 1, name: tool.title, url: `${SITE_BASE_URL}${tool.route}` })) },
    ],
  }),
  component: () => <><ToolsIndexPage /><HubSeoContent hub="tools" /></>,
});
